export const SYNC_DISABLED_TOOLTIP = 'This team is synced from an external provider and cannot be modified here.'
